import { createAPIMethod, type Pagination } from 'utils/generic';
import {
	normalizePlaOfferData,
	normalizePromoOfferData,
	type ResponseZboziPlaOfferData,
	type ZboziPlaOfferData,
	type ResponseZboziPromoOfferData,
	type ZboziPromoOfferData,
} from 'service/zbozi/model';

interface GetPlaOffersParams {
	phrase: string;
	limit: number;
}

export interface GetPlaOffers {
	results: ZboziPlaOfferData[];
	pagination: Pagination;
}

export function getPlaOffers(params: GetPlaOffersParams, headers?: HeadersInit, abortController?: AbortController) {
	return createAPIMethod<GetPlaOffersParams, GetPlaOffers>({
		path: '/zbozi/pla_offers',
		method: 'GET',
		normalize: ({ results }) => ({
			results: results.map((data: ResponseZboziPlaOfferData) => normalizePlaOfferData(data)),
			pagination: {
				limit: results.length,
				total: results.length,
				offset: 0,
			},
		}),
		abortController,
		headers,
	})(params);
}

interface GetPromoOffersParams {
	phrase: string;
	limit: number;
}

export interface GetPromoOffers {
	results: ZboziPromoOfferData[];
	pagination: Pagination;
}

export function getPromoOffers(params: GetPromoOffersParams, headers?: HeadersInit, abortController?: AbortController) {
	return createAPIMethod<GetPromoOffersParams, GetPromoOffers>({
		path: '/zbozi/search/sbazar',
		method: 'GET',
		normalize: ({ results }) => ({
			results: results.map((data: ResponseZboziPromoOfferData) => normalizePromoOfferData(data)),
			pagination: {
				limit: results.length,
				total: results.length,
				offset: 0,
			},
		}),
		abortController,
		headers,
	})(params);
}

interface PostImpressionParams {
	impression: string[];
	impression_control: string;
}

export function postImpression(params: PostImpressionParams, headers?: HeadersInit) {
	return createAPIMethod<PostImpressionParams, void>({
		path: '/zbozi/impression',
		method: 'POST',
		headers,
	})(params);
}
